import React, { Component } from "react";
import { Row, Col, Alert } from "reactstrap";

import { FetchData } from "../utils/DataFetch";
import { GetCookie } from "../utils/Common";
import {
  RptAccountsReceivableTableByAge,
  columns as rptAccountsReceivableByAgeColumns,
} from "./RptAccountsReceivableTableByAge";

import {
  RptAccountsReceivableTableByCompany,
  columns as rptAccountsReceivableByCompanyColumns,
} from "./RptAccountsReceivableTableByCompany";
import { exportRowsToExcel } from "../utils/ReportExport";
import { ExcelExportButton } from "./ExcelExportButton";

export class RptAccountsReceivable extends Component {
  static displayName = RptAccountsReceivable.name;

  constructor(props) {
    super(props);
    this.state = {
      rptAccountsReceivable: null,
      loading: false,
      fetchingData: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      searchModel: {
        ClientABBRV: "",
        StartDate: "",
        EndDate: "",
      },
    };
    this.user = JSON.parse(GetCookie("user"));

    this.renderRptAccountsReceivableByCompanyTable =
      this.renderRptAccountsReceivableByCompanyTable.bind(this);
    this.renderRptAccountsReceivableByAgeTable =
      this.renderRptAccountsReceivableByAgeTable.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.exportAccountsReceivableByAge =
      this.exportAccountsReceivableByAge.bind(this);
    this.exportAccountsReceivableByCompany =
      this.exportAccountsReceivableByCompany.bind(this);
    //
  }

  componentDidMount() {
    this.populateRptAccountsReceivableData();
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateRptAccountsReceivableData();
    }
  }

  renderRptAccountsReceivableByCompanyTable(rptAccountsReceivable) {
    if (
      !rptAccountsReceivable ||
      !rptAccountsReceivable.accountsReceivableByCompany
    ) {
      // Add a condition to handle the case when rptAccountsReceivable is null or undefined
      return null; // or handle it accordingly
    }

    return (
      <RptAccountsReceivableTableByCompany
        rptAccountsReceivableByCompany={
          rptAccountsReceivable.accountsReceivableByCompany
        }
        state={this.state}
      ></RptAccountsReceivableTableByCompany>
    );
  }
  renderRptAccountsReceivableByAgeTable(rptAccountsReceivable) {
    if (
      !rptAccountsReceivable ||
      !rptAccountsReceivable.accountsReceivableByAge
    ) {
      // Add a condition to handle the case when rptAccountsReceivable is null or undefined
      return null; // or handle it accordingly
    }

    return (
      <RptAccountsReceivableTableByAge
        rptAccountsReceivableByAge={
          rptAccountsReceivable.accountsReceivableByAge
        }
        state={this.state}
      ></RptAccountsReceivableTableByAge>
    );
  }

  async populateRptAccountsReceivableData() {
    this.setState({ fetchingData: true });

    FetchData(
      "/getrptaccountsreceivable",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({
        rptAccountsReceivable: data,
        loading: false,
        fetchingData: false,
      });
      //let test = FetchData("/getrptaccountsreceivable", "POST", this.user.token, this.state.searchModel);
    });

    console.log(this.state.rptAccountsReceivable);
  }

  exportAccountsReceivableByAge() {
    const rows = this.state.rptAccountsReceivable?.accountsReceivableByAge;
    exportRowsToExcel({
      rows: Array.isArray(rows) || rows ? rows : [],
      columns: rptAccountsReceivableByAgeColumns,
      fileName: "AccountsReceivableByAge.xlsx",
    });
  }

  exportAccountsReceivableByCompany() {
    const rows = this.state.rptAccountsReceivable?.accountsReceivableByCompany;
    exportRowsToExcel({
      rows: Array.isArray(rows) || rows ? rows : [],
      columns: rptAccountsReceivableByCompanyColumns,
      fileName: "AccountsReceivableByCompany.xlsx",
    });
  }

  render() {
    let byAgeContents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRptAccountsReceivableByAgeTable(
        this.state.rptAccountsReceivable
      )
    );

    let byCompanyContents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRptAccountsReceivableByCompanyTable(
        this.state.rptAccountsReceivable
      )
    );

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Accounts Receivable Report</h5>

        <hr />

        <div>
          <Row className="align-items-center">
            <Col>
              <strong>By Age:</strong>
            </Col>
            <Col className="text-end">
              <ExcelExportButton
                onClick={this.exportAccountsReceivableByAge}
                title="Export Accounts Receivable By Age"
              />
            </Col>
          </Row>
          {byAgeContents}
        </div>
        <div>
          <Row className="align-items-center mt-3">
            <Col>
              <strong>By Company:</strong>
            </Col>
            <Col className="text-end">
              <ExcelExportButton
                onClick={this.exportAccountsReceivableByCompany}
                title="Export Accounts Receivable By Company"
              />
            </Col>
          </Row>
          {byCompanyContents}
        </div>
      </div>
    );
  }
}
